const customPopUpWithLoaderStyle = () => ({
	confirmationDialogLoader: {
		height: '228px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	bodyWrapper: {
		marginBottom: 25,
	},
});

export default customPopUpWithLoaderStyle;
